
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../components/base/Button';

export const TravelWithUsSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-teal-600 mb-8">
              Travel With Us
            </h2>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Ever since we opened our doors in 2018 our main goal was to help travelers discover the innumerable wonders our planet has in store for us. Prime Meridian will guide you through the process, from booking a trip to your specifications to making sure you won't miss out on any of the attractions your destination has to offer. Ready to make lifelong memories? Request an itinerary today.
            </p>

            <Link to="/about" aria-label="Our profile — about us">
              <Button variant="primary" size="lg">
                <i className="ri-file-text-line w-5 h-5 flex items-center justify-center"></i>
                Our Profile
              </Button>
            </Link>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="/images/travel-with-us.jpg"
              alt="View from a window"
              className="w-full h-96 lg:h-[520px] object-cover rounded-2xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
